module.exports = __webpack_public_path__ + "static/maya-angelou-3641159f062a47f8735408054686a9b1.jpg";